import { useState, useEffect, useMemo } from 'react';
import api from '../api';

const money = (n) => `${Math.round(Number(n || 0)).toLocaleString('ru')} ₽`;

// Раздел «Проекты» для дизайнера — те же данные, что и на странице «Дизайнеры»
// (/api/design-tasks уже отдаёт только его собственные назначения), но сгруппированные
// по проекту: дизайнер должен знать только сумму своей зарплаты за проект, без бюджета
// сделки и прочих финансовых показателей, которые видят админ/РОП/менеджер.
export default function DesignerProjects() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/design-tasks').then(r => setTasks(r.data)).finally(() => setLoading(false));
  }, []);

  const projects = useMemo(() => {
    const map = new Map();
    for (const t of tasks) {
      if (!map.has(t.project_id)) {
        map.set(t.project_id, { id: t.project_id, name: t.project_name, tasksTotal: 0, tasksDone: 0, salary: 0 });
      }
      const p = map.get(t.project_id);
      p.tasksTotal += 1;
      if (t.is_done) { p.tasksDone += 1; p.salary += Number(t.total_amount || 0); }
    }
    return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name, 'ru'));
  }, [tasks]);

  const totalSalary = projects.reduce((s, p) => s + p.salary, 0);

  if (loading) return <div className="loading-text">Загрузка...</div>;

  return (
    <div>
      <div className="toolbar">
        <h2>Проекты</h2>
        <div className="toolbar-spacer" />
        <span className="text-muted">Всего заработано: <b>{money(totalSalary)}</b></span>
      </div>
      {projects.length === 0 ? (
        <div className="empty-state">Вам пока не назначено ни одного проекта</div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead><tr><th>Проект</th><th>Задачи</th><th>Готово</th><th>Моя ЗП</th></tr></thead>
            <tbody>
              {projects.map(p => (
                <tr key={p.id}>
                  <td>{p.name}</td>
                  <td>{p.tasksTotal}</td>
                  <td>{p.tasksDone}</td>
                  <td><b>{money(p.salary)}</b></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
